import fs from 'fs'
import path from 'path'

let commit: string | null = null

export function getGitCommit() {
  if (commit != null) {
    return commit
  }
  commit = getConfigValue('commitHash.txt')
  return commit
}

export function getGitHubPrivateKey() {
  return getConfigValue('github_private_key.pem').replace(/\\n/gm, '\n')
}

/**
 * Reads the value of a specified file. The file must be in the same directory as this script.
 *
 * Returns 'unknown' if the file cannot be found.
 */
function getConfigValue(filename: string) {
  try {
    return fs.readFileSync(path.join(__dirname, filename)).toString().trim()
  } catch (e) {
    console.log(`cannot read ${filename}: ${e}`)
    return 'unknown'
  }
}
